import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetTechArea } from '@/infrastructure/api-functions/interface/get-tech-area.interface';
import type { AISearchRepository } from '../../service/ai-search.repository.interface';
import _ from 'lodash';

export const GetTechAreaDTO = Symbol('GetTechAreaDTO');

export interface GetTechAreaDTO {
    fetch: AISearchRepository['getSummary'];
}

@injectable()
export class GetTechAreaDTOImpl implements GetTechAreaDTO {
    private _IPC_PREFIX = 'ipc_';

    constructor(
        @inject(GetTechArea)
        private readonly _getTechAreaApi: GetTechArea,
    ){}

    private _createId() {
        return _.uniqueId(this._IPC_PREFIX);
    }

    async fetch(taskId: string, desc: string) {
        const data = await this._getTechAreaApi.getTechArea({
            task_id: taskId,
            tech_desc: desc,
        });
        return {
            topic: data.area?.feature,
            relatedIpc: data.area?.related_ipc.map(ipc => {
                return {
                    ...ipc,
                    id: this._createId(),
                };
            }),
            summary: (data.topics || []).map(topic => {
                return {
                    feature: topic.feature,
                    desc: topic.desc,
                    relatedIpc: topic.related_ipc.map(ipc => {
                        return {
                            ...ipc,
                            id: this._createId(),
                        };
                    }),
                };
            }),
        };
    }
}
